module.exports = __webpack_public_path__ + "static/bg-down.de9b0e48.png";